import { html, View } from 'rune-ts';

/**
 * 게임 종료 시 1회성 화면 중앙 🏆 + 좌우 폭죽 emoji scatter.
 * GamePage가 status FINISHED 첫 감지 시 1회 마운트 (finishedTriggered flag).
 * 3초 후 ResultPage로 navigate되어 페이지 자체가 unmount.
 */
export type WinCelebrationData = {
  isMe: boolean;
};

const CONFETTI_COUNT = 14;
const CONFETTI_EMOJIS = ['🎉', '✨', '🎊', '🌟', '💫'] as const;

export class WinCelebrationView extends View<WinCelebrationData> {
  override template() {
    const confetti: ReturnType<typeof html>[] = [];
    for (let i = 0; i < CONFETTI_COUNT; i++) {
      const left = Math.round(Math.random() * 90 + 5);
      const delay = Math.round(Math.random() * 700);
      const duration = 1400 + Math.round(Math.random() * 600);
      const fontSize = 1.6 + Math.random() * 0.8;
      const emoji = CONFETTI_EMOJIS[i % CONFETTI_EMOJIS.length];
      confetti.push(html`
        <span
          class="win-confetti absolute top-0 select-none pointer-events-none"
          style="left: ${left}%; font-size: ${fontSize.toFixed(2)}rem; animation-delay: ${delay}ms; animation-duration: ${duration}ms"
        >${emoji}</span>
      `);
    }

    return html`
      <div class="win-celebration fixed inset-0 z-50 pointer-events-none flex items-center justify-center overflow-hidden">
        <div class="trophy-pop text-7xl sm:text-8xl drop-shadow-2xl">🏆</div>
        ${confetti}
      </div>
    `;
  }
}
